import { TranslateResult } from 'vue-i18n'

/* eslint-disable import/prefer-default-export */
export interface ICategory {
  id: number;
  name: string;
  color: string;
  translations: ICategoryTranslation[];
  description?: string;
  label?: string | TranslateResult;
}

export type ICategoryPayload = Omit<ICategory, 'id'>

export interface ICategoryTranslation {
  name: string;
  language: string;
  description: null | string;
  label?: string | TranslateResult;
}

export const translateCategory = (category: ICategory, language: string): string => {
  const translation = category.translations.find((t) => t.language === language)
  return translation ? translation.name : category.name
}
